module.exports = __webpack_public_path__ + "img/fossil5Img1.0d2eab60.jpg";